
















































































import { defineComponent, ref, reactive } from "@vue/composition-api";
import { ContactApi, ContactInformationCommand } from "@/api";
import Store from "@/store";
import { mapValidationErrors } from "@/util/Forms";

export default defineComponent({
  setup(props, vm) {
    const api = new ContactApi();
    const form = ref<HTMLFormElement>();

    const contactForm = reactive({
      errors: {},
      isValid: false,
      fields: {
        subject: ref(""),
        message: ref(""),
      },
    });

    async function submitContactForm() {
      const contactCommand: ContactInformationCommand = {
        projectId: Store.getters["User/getSelectedProject"].projectId,
        subject: contactForm.fields.subject,
        message: contactForm.fields.message,
      };
      api
        .contactContactInformationEmail(contactCommand)
        .then(() => {
          vm.root.$emit("snackbar", "Het bericht is verzonden");
          contactForm.fields.subject = "";
          contactForm.fields.message = "";
          if (form.value) {
            form.value.resetValidation();
          }
        })
        .catch((err) => {
          contactForm.errors = err.response.data.errors;
        });
    }

    async function onSubmit() {
      if (contactForm.isValid) {
        await submitContactForm();
      }
    }

    return {
      form,
      onSubmit,
      mapValidationErrors,
      contactForm,
    };
  },
});
